







import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';

@Component({})
export default class PartnerStatusIcon extends Vue {
  @Prop({ default: 'complete' }) status!: string;

  @Prop({ default: 'green' }) color!: string;
}
